/*
 * jQuery plugin to make requests from the RocSitefinity client app through proxy.
 *
 * Example usage:
 * 1) Add dependency in your module:
 *      define([
 *          ...,
 *          'plugins/jquery.proxyRequest'
 *      ],
 *
 * 2) Call '$.proxyRequest' function wherever you need:
 *      $.proxyRequest({
 *          type: 'POST',
 *          url: '/api/store/cart/summary/',
 *          data: JSON.stringify({orderId: '{orderId}'}),
 *          contentType: 'application/json; charset=utf-8',
 *          complete: function (xhr) {
 *              Roc.EventManager.notify(Roc.Events.cart.GET_SUMMARY, xhr);
 *          }
 *      });
 *
 *  Note: you can specify the same parameters as for $.ajax function:
 *  Reference: http://api.jquery.com/jquery.ajax/
 *
 */
(function ($) {
    $.proxyRequest = function (options) {

        // collect data from original request
        var proxyData = {
            'url': options.url,
            'data': options.data,
            'contentType': options.contentType || 'application/json; charset=utf-8',
            'method': options.type,
            'serverCompleteAction': options.serverCompleteAction
        };

        // modify original options
        options.type = 'POST';
        options.url = '/ProxyRequest.aspx';
        options.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
        options.data = proxyData;

        return $.ajax(options);
    }
})(jQuery);

define("plugins/jquery.proxyRequest", ["jquery"], function(){});

